import { render, staticRenderFns } from "./MovieDetail.vue?vue&type=template&id=4bf19998"
import script from "./MovieDetail.vue?vue&type=script&lang=js"
export * from "./MovieDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports